import { render, staticRenderFns } from "./ChapterInfo.vue?vue&type=template&id=54dc4555&scoped=true"
import script from "./ChapterInfo.vue?vue&type=script&lang=js"
export * from "./ChapterInfo.vue?vue&type=script&lang=js"
import style0 from "./ChapterInfo.vue?vue&type=style&index=0&id=54dc4555&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc4555",
  null
  
)

export default component.exports